import React from 'react'
import { useSelector } from 'react-redux';
import { Experience, MinBaseSalary, Roles, Type } from '../../Constants';
import { InputField, SelectField } from '../../Common';
import './filters.css';

const Filters = () => {
  const common = useSelector((state) => state.common);

  return (
    <div className='filter-container'>
      <SelectField
        label={'Roles'}
        items={Roles}
        value={common.Roles}
        multiple={true}
      />
      <SelectField
        label={'Experience'}
        items={Experience}
        value={common.Experience}
      />
      <SelectField
        label={'jobType'}
        items={Type}
        value={common.jobType}
        multiple={true}
      />
      <SelectField
        label={'basePay'}
        items={MinBaseSalary}
        value={common.basePay}
      />
      <InputField
        label={'companyName'}
        value={common.companyName}
      />
    </div>
  )
}

export default Filters;
